import React from 'react';
import { parseISO, format } from 'date-fns';
import { withStyles } from '@material-ui/core/styles';
import {
  LinearProgress,
  Typography,
  Paper,
  Divider,
  Grid,
  Button,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import InfoIcon from "@material-ui/icons/InfoOutlined";
import classNames from 'classnames';

const PropertyImportItem = ({ classes, importItem, handleRedirect, handleOpen }) => {

  const completed = importItem.progressMessages.length * 4;   // there are 25 messages currently to complete an import (100/25 = 4), caveat: these messages can get multiplied if a retry occurs
  const buffer = completed + (Math.random() * 10);

  let linearProgress;
  let progressState;
  if (importItem.isFaulted) {
    linearProgress = <LinearProgress variant='determinate' color='secondary' value={completed} />      // isFaulted is set at the end if the import ended with errors
    progressState = { message: 'Failed', class: 'failedProgressStatus' };
  } else if (importItem.importCompletedOn === undefined) {
    linearProgress = <LinearProgress variant="buffer" value={completed} classes={{ colorPrimary: classes.inProgressLinearColorPrimary, barColorPrimary: classes.inProgressLinearBarColorPrimary }} valueBuffer={buffer} />      // this progress bar will show while in progress
    progressState = { message: 'In Progress', class: 'inProgressProgressStatus' };
  } else if (importItem.warningMessages.length > 0) {             // once complete, it will either be yellow if there were warnings, or blue completed without errors
    linearProgress = <LinearProgress variant='determinate' classes={{ colorPrimary: classes.warninglinearColorPrimary, barColorPrimary: classes.warninglinearBarColorPrimary, }} value={100} />
    progressState = { message: 'Warning', class: 'warningProgressStatus' };
  } else {
    linearProgress = <LinearProgress variant="determinate" value={100} />
    progressState = { message: 'Success', class: 'successProgressStatus' };
  }

  return (
    <div className={classes.itemContainer}>
      <Paper className={classes.paperContainer} elevation={1}>
        <Grid container>
          <div style={{ flexGrow: 1 }}>
            <Typography className={classNames(classes[progressState.class], classes.fontBold)}>{progressState.message}</Typography>
            <div className={classes.progressHeader}>
              <Typography>
                <span className={classes.fontBold}>{importItem.importName}</span>
                {` (${importItem.importCount} properties), imported by `}
                <span className={classes.fontBold}>{importItem.importedBy}</span>
              </Typography>
              <Divider className={classes.verticalDivider} />
              <Typography>
                <span className={classes.fontBold}>Started on:</span> {format(parseISO(importItem.importedOn), 'MM/dd/yyyy, h:mm:ss a')}
              </Typography>
              {importItem.importCompletedOn != null &&
                <>
                  <Divider className={classes.verticalDivider} />
                  <Typography>
                    <span className={classes.fontBold}>Completed on:</span> {format(parseISO(importItem.importCompletedOn), 'MM/dd/yyyy, h:mm:ss a')}
                  </Typography>
                </>
              }
              {importItem.log?.length &&
                <Tooltip title='View Import Log'>
                  <IconButton style={{ marginLeft: 4, padding: 2 }} onClick={() => handleOpen(importItem.log)}>
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
              }
            </div>
            {importItem.importCompletedOn === undefined && !importItem.isFaulted &&
              <Typography>{importItem.progressMessages[importItem.progressMessages.length - 1]}</Typography>
            }
            {importItem.errorMessages.length > 0 ?
              importItem.errorMessages.map((e, i) => <Typography key={i}>{e}</Typography>)
              :
              importItem.warningMessages.map((w, i) => <Typography key={i}>{w}</Typography>)
            }
          </div>

          <div>
            <Button variant='contained' color='primary' onClick={() => { !importItem.isFaulted && handleRedirect(importItem) }} disabled={progressState.message !== 'Success'}>View on Explore</Button>
          </div>
        </Grid>
        <Divider className={classes.divider} />
        <div className={classes.progressContainer}>
          {linearProgress}
        </div>
      </Paper>
    </div>
  )
}

const styles = theme => ({
  itemContainer: {
    marginBottom: theme.spacing(1.5),
  },
  warninglinearColorPrimary: {
    backgroundColor: '#ffffcc',
  },
  warninglinearBarColorPrimary: {
    backgroundColor: '#cccc00',
  },
  inProgressLinearColorPrimary: {
    backgroundColor: 'lightgray',
  },
  inProgressLinearBarColorPrimary: {
    backgroundColor: 'gray',
  },
  paperContainer: {
    padding: theme.spacing(1),
  },
  inProgressProgressStatus: {
    color: 'gray',
  },
  warningProgressStatus: {
    color: '#cccc00',
  },
  failedProgressStatus: {
    color: 'red',
  },
  successProgressStatus: {
    color: '#2196f3',
  },
  progressHeader: {
    display: 'flex',
    // justifyContent: 'space-between',
    alignItems: 'center',
    height: 20
  },
  progressContainer: {
    marginTop: theme.spacing(1)
  },
  fontBold: {
    fontWeight: 'bold',
  },
  divider: {
    margin: `${theme.spacing(0.5)}px 0`
  },
  verticalDivider: {
    width: 1,
    height: 20,
    margin: '0px 6px',
  },
});

export default withStyles(styles)(PropertyImportItem);